import script from "./RequestUploads.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestUploads.vue?vue&type=script&setup=true&lang=ts"

import "./RequestUploads.vue?vue&type=style&index=0&id=64a54482&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a54482"]])

export default __exports__